<template>
  <el-select
    :loading="loading"
    :value="selected"
    :placeholder="placeholderI18n"
    :disabled="disabled"
    @change="update"
  >
    <el-option v-for="item in options" :key="item.name" :label="item.name" :value="item.id">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'Dropdown',
  props: {
    selected: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  created() {
    this.$emit('change', this.selected);
  },
  computed: {
    loading() {
      return !this.options.length;
    },
    placeholderI18n() {
      return this.$t('settings.dropDownPlaceholder');
    },
  },
  methods: {
    update(item) {
      this.$emit('change', item);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';

.el-select-dropdown {
  &__item {
    font-family: 'Avenir';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dropdown.vue